<template>
  <div>
    <div v-if="isConnected">
      <div class="font-weight-medium text-center pb-5">
        Bonjour {{ me.firstname }},
      </div>
      <v-alert type="success" text color="white" class="mb-5">
        Félicitations vous êtes déjà connecté
      </v-alert>
      <v-row no-gutters justify="center" align="center">
        <v-col class="pr-2">
          <v-btn
            dark
            large
            text
            block
            depressed
            class="n-btn"
            @click="logout"
          >
            <v-icon class="mr-1">logout</v-icon>
            Se déconnecter
          </v-btn>
        </v-col>
        <v-col class="pl-2">
          <v-btn
            dark
            large
            block
            depressed
            class="n-secondary-btn"
            @click="goNext"
          >
            <v-icon class="mr-1">forward</v-icon>
            Continuer
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-form @submit.native.prevent="submit" v-else-if="isLoginWithEmail">
      <v-alert type="error" text class="mb-5" v-if="isServerError">Informations incorrectes</v-alert>
      <v-row no-gutters justify="center" align="center">
        <v-text-field
          v-model="username"
          :error="isUsernameError"
          :disabled="isSubmitting"
          dark
          outlined
          flat
          autofocus
          :placeholder="isGlobalApp ? `E-mail` : `Identifiant`"
          prepend-inner-icon="person"
        />
      </v-row>
      <v-row no-gutters justify="center" align="center">
        <v-text-field
          v-model="password"
          type="password"
          :error="isPasswordError"
          :disabled="isSubmitting"
          dark
          outlined
          flat
          placeholder="Mot de passe"
          prepend-inner-icon="lock"
        />
      </v-row>
      <v-btn
        type="submit"
        dark
        large
        block
        depressed
        :loading="isSubmitting"
        class="n-secondary-btn"
      >
        <v-icon class="mr-1">forward</v-icon>
        Connexion
      </v-btn>
      <v-row no-gutters justify="center" align="center" class="pt-4" v-if="isGlobalApp">
        <v-btn
          text
          :disabled="isSubmitting"
          color="grey lighten-1"
          class="n-btn mt-3"
          @click="isLoginWithEmail = false"
          style="height: auto !important;"
        >
          Se connecter sans email avec un identifiant
        </v-btn>
      </v-row>
      <v-row no-gutters justify="center" align="center" v-if="isGlobalApp">
        <v-btn
          text
          :disabled="isSubmitting"
          color="grey lighten-1"
          class="n-btn mt-3"
          href="https://www.indeego.fr/pricing"
          style="height: auto !important;"
        >
          Pas encore de compte ? Inscrivez-vous
        </v-btn>
      </v-row>
      <v-row no-gutters justify="center" align="center">
        <v-btn
          text
          :disabled="isSubmitting"
          color="grey lighten-1"
          class="n-btn mt-3"
          :to="{ name: `forgotPassword` }"
          style="height: auto !important;"
        >
          Mot de passe oublié ?
        </v-btn>
      </v-row>
    </v-form>
    <v-form @submit.native.prevent="submit" v-else>
      <v-alert type="error" text class="mb-5" v-if="isServerError">Informations incorrectes</v-alert>
      <v-row no-gutters justify="center" align="center">
        <v-text-field
          v-model="slug"
          :error="isSlugError"
          :disabled="isSubmitting"
          dark
          outlined
          flat
          autofocus
          placeholder="Identifiant client"
          prepend-inner-icon="badge"
        />
      </v-row>
      <v-row no-gutters justify="center" align="center">
        <v-text-field
          v-model="username"
          :error="isUsernameError"
          :disabled="isSubmitting"
          dark
          outlined
          flat
          autofocus
          placeholder="Identifiant"
          prepend-inner-icon="person"
        />
      </v-row>
      <v-row no-gutters justify="center" align="center">
        <v-text-field
          v-model="password"
          type="password"
          :error="isPasswordError"
          :disabled="isSubmitting"
          dark
          outlined
          flat
          placeholder="Mot de passe"
          prepend-inner-icon="lock"
        />
      </v-row>
      <v-btn
        type="submit"
        dark
        large
        block
        depressed
        :loading="isSubmitting"
        class="n-secondary-btn"
      >
        <v-icon class="mr-1">forward</v-icon>
        Connexion
      </v-btn>
      <v-row no-gutters justify="center" align="center" class="pt-4">
        <v-btn
          text
          :disabled="isSubmitting"
          color="grey lighten-1"
          class="n-btn mt-3"
          @click="isLoginWithEmail = true"
          style="height: auto !important;"
        >
          Se connecter avec un email
        </v-btn>
      </v-row>
      <v-row no-gutters justify="center" align="center">
        <v-btn
          text
          :disabled="isSubmitting"
          color="grey lighten-1"
          class="n-btn mt-3"
          :to="{ name: `forgotPassword` }"
          style="height: auto !important;"
        >
          Mot de passe oublié ?
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';

export default {
  name: `Login`,

  data: () => ({
    isSlugError: false,
    isUsernameError: false,
    isPasswordError: false,
    isServerError: false,
    isSubmitting: false,
  }),

  computed: {
    ...mapState(`model/auth`, [
      `accessToken`,
      `spaces`,
    ]),
    ...mapState(`model/user`, [
      `me`,
    ]),
    ...mapState(`ui/login`, [
      `originPath`,
    ]),
    ...mapGetters(`ui/mainLayout`, [
      `isGlobalApp`,
    ]),
    exportDestination() { return this.$route.query.redirect === `/data-exports` || this.originPath === `/data-exports`; },
    isConnected() {
      return Boolean(this.me && this.me.id);
    },
    isLoginWithEmail: {
      get() { return this.$store.state[`ui/login`].isLoginWithEmail; },
      set(value) { this.$store.commit(`ui/login/SET_IS_LOGIN_WITH_EMAIL`, value); },
    },
    slug: {
      get() { return this.$store.state[`ui/login`].slug; },
      set(value) { this.$store.commit(`ui/login/SET_SLUG`, _.trim(value)); },
    },
    username: {
      get() { return this.$store.state[`ui/login`].username; },
      set(value) { this.$store.commit(`ui/login/SET_USERNAME`, value); },
    },
    password: {
      get() { return this.$store.state[`ui/login`].password; },
      set(value) { this.$store.commit(`ui/login/SET_PASSWORD`, value); },
    },
  },

  methods: {
    goNext() {
      this.$router.replace(this.exportDestination ? `/data-exports` : this.originPath);
    },
    async logout() {
      await this.$store.dispatch(`model/auth/logout`);
    },
    async submit() {
      this.isSlugError = false;
      this.isUsernameError = false;
      this.isPasswordError = false;
      this.isServerError = false;

      if (_.trim(this.slug) === `` && !this.isLoginWithEmail) { this.isSlugError = true; }
      if (_.trim(this.username) === ``) { this.isUsernameError = true; }
      if (_.trim(this.password) === ``) { this.isPasswordError = true; }

      if (this.isSlugError || this.isUsernameError || this.isPasswordError) { return; }

      this.isSubmitting = true;
      const authRes = await this.$store.dispatch(`ui/login/login`);

      if (authRes?.ssoToken) {
        let ssoUrl = `${authRes.slugUrl}/sso?token=${authRes.ssoToken}&logout=1&unified=1`;
        if (this.exportDestination) ssoUrl += `&r=${encodeURIComponent(`/data-exports`)}`;

        if (ssoUrl.indexOf(`http:`) !== 0) {
          const protocol = window.location.protocol; // eslint-disable-line
          ssoUrl = `${protocol}//${ssoUrl}`;
        }

        window.location.href = ssoUrl;
      } else {
        this.isSubmitting = false;
        if (!this.isGlobalApp) {
          if (!this.accessToken) {
            this.isServerError = true;
          } else {
            this.goNext();
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
</style>
